import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: null,
  sys_role: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.sys_role = action.payload.sys_role;
    },
    logout: (state) => {
      state.accessToken = null;
      state.sys_role = null;
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
